import React from "react";

/**
 * AdSlot — Ads are fully disabled site-wide. This component is a no-op.
 * Kept as a compatibility shim so existing imports/usages keep working.
 */
export default function AdSlot() {
  return null;
}
